<template>
  <div>
    <h2 class="auth-heading">Welcome to the Metering and Billing Portal</h2>
    <v-card-text>

      <p>If you are a Freeholder or Managing Agent and we are managing the tenant billing or data collection for your development(s), please log in below with the details that have been provided to you.</p>

      <p>If you do not have login details, please get in touch with your Heat Network Manager to register.</p>


      <v-form ref="form" class="mx-2" v-model="valid" lazy-validation @keyup.native.enter="submitForm">
        <v-text-field
          name="login"
          label="E-mail"
          type="email"
          v-model="email"
          :rules="emailRules"
        ></v-text-field>
        <v-text-field
          id="password"
          name="password"
          label="Password"
          type="password"
          :rules="passwordRules"
          v-model="password"
        ></v-text-field>
        <div style="text-align: right;">
        <router-link to="/password-forgot" class="button">
          Forgotten password?
        </router-link>
        </div>

      </v-form>
    </v-card-text>
    <v-card-actions>

      <div style="width: 75%;margin: auto;">
        <v-btn block class="center-button" color="primary" type="submit" @click="submitForm">Login</v-btn>
      </div>


    </v-card-actions>
  </div>
</template>

<script>
import {recaptcha} from "@/mixins/captcha";

export default {
  name: "InitialLogin",
  mixins: [recaptcha],
  data: () => ({
    email: '',
    valid: null,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Password is required'
    ],
  }),
  methods: {
    async submitForm() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        const detail = "Please enter all fields required";
        await this.$store.dispatch("notification/triggerError", { detail: detail });
        return;
      }

      await this.$store.dispatch("loader/loaderInitiate", { title: "Logging in" });

      const captcha = await this.recaptchaToken();

      const email = this.email;
      const password = this.password;
      const result = await this.$store.dispatch("auth/login", { email, password, captcha });

      await this.$store.dispatch("loader/loaderCancel");

      if (result.state === 'success') {
        this.$emit('loginSuccess');
      }

      if (result.state === 'redirect_third_party') {
        this.$emit('utilityClick', result.third_party.account, result.third_party.otp);
        return;
      }

      if (result.state !== 'fail') {
        this.$emit('changeState', result.state);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.auth-heading {
  text-transform: none !important;
  background-color: #5d3791;
  color: white !important;
  padding: 15px 10px;
}

.center-button {
  width: 70%;
}

p {
  text-align: center;
}
</style>
